const es = {
    // Cámara
    cameraMinSpecificationsHeadingText:
        'La cámara no cumple con los requisitos mínimos.',

    cameraMinSpecificationsMessageText:
        'La cámara debe admitir una resolución mínima de 320 × 240 píxeles y al menos 15 fotogramas por segundo.',

    cameraNotFoundHeadingText:
        'No se pudo acceder a la cámara.',

    cameraNotFoundMessageText:
        'Verifica que la cámara esté conectada, que ninguna otra aplicación la esté utilizando y que hayas concedido los permisos necesarios al navegador. Si es necesario, cierra el navegador e inténtalo nuevamente.',

    waitingCameraPermissionText:
        'Esperando tu autorización para acceder a la cámara.',

    retryCameraPermissionsText:
        'Reintentar',

    a11yVideoLabelText:
        'Cámara para la verificación de identidad',

    // Pantalla inicial
    photosensitivityWarningHeadingText:
        'Advertencia sobre fotosensibilidad',

    photosensitivityWarningBodyText:
        'Esta verificación utiliza luces de distintos colores. Si eres sensible a los destellos de luz, procede con precaución.',

    photosensitivityWarningInfoText:
        'Algunas personas pueden experimentar convulsiones al exponerse a luces intermitentes o de colores. Si tú o algún miembro de tu familia tiene antecedentes de epilepsia, procede con precaución.',

    photosensitivityWarningLabelText:
        'Más información sobre fotosensibilidad',

    // Compatibilidad con versiones anteriores
    photosensitivyWarningHeadingText:
        'Advertencia sobre fotosensibilidad',

    photosensitivyWarningBodyText:
        'Esta verificación utiliza luces de distintos colores. Si eres sensible a los destellos de luz, procede con precaución.',

    photosensitivyWarningInfoText:
        'Algunas personas pueden experimentar convulsiones al exponerse a luces intermitentes o de colores. Si tú o algún miembro de tu familia tiene antecedentes de epilepsia, procede con precaución.',

    photosensitivyWarningLabelText:
        'Más información sobre fotosensibilidad',

    startScreenBeginCheckText:
        'Iniciar verificación',

    goodFitCaptionText:
        'Posición correcta',

    goodFitAltText:
        'Ilustración de un rostro correctamente alineado dentro del óvalo.',

    tooFarCaptionText:
        'Muy lejos',

    tooFarAltText:
        'Ilustración de un rostro demasiado alejado del óvalo.',

    // Indicaciones
    hintCenterFaceText:
        'Centra tu rostro',

    hintCenterFaceInstructionText:
        'Antes de comenzar, asegúrate de que la cámara esté frente a ti y centra tu rostro. Cuando aparezca el óvalo, acércate hasta ajustarte a él y permanece quieto hasta completar la verificación.',

    hintFaceOffCenterText:
        'Coloca tu rostro dentro del óvalo.',

    hintMoveFaceFrontOfCameraText:
        'Coloca tu rostro frente a la cámara.',

    hintTooManyFacesText:
        'Solo debe aparecer una persona frente a la cámara.',

    hintFaceDetectedText:
        'Rostro detectado.',

    hintCanNotIdentifyText:
        'No se pudo detectar tu rostro.',

    hintTooCloseText:
        'Aléjate un poco.',

    hintTooFarText:
        'Acércate un poco.',

    hintConnectingText:
        'Conectando...',

    hintVerifyingText:
        'Verificando identidad...',

    hintCheckCompleteText:
        'Verificación completada.',

    hintIlluminationTooBrightText:
        'Reduce la iluminación.',

    hintIlluminationTooDarkText:
        'Busca un lugar con mejor iluminación.',

    hintIlluminationNormalText:
        'Iluminación adecuada.',

    hintHoldFaceForFreshnessText:
        'Permanece quieto.',

    hintMatchIndicatorText:
        '50 % completado. Continúa acercándote.',

    // Grabación
    recordingIndicatorText:
        'Grabando',

    cancelLivenessCheckText:
        'Cancelar verificación',

    // Errores
    errorLabelText:
        'Error',

    connectionTimeoutHeaderText:
        'Tiempo de conexión agotado',

    connectionTimeoutMessageText:
        'La conexión tardó demasiado en responder.',

    timeoutHeaderText:
        'Tiempo agotado',

    timeoutMessageText:
        'No fue posible completar la verificación dentro del tiempo establecido. Inténtalo nuevamente manteniendo tu rostro dentro del óvalo.',

    faceDistanceHeaderText:
        'Movimiento detectado',

    faceDistanceMessageText:
        'Evita acercarte demasiado mientras se realiza la verificación.',

    multipleFacesHeaderText:
        'Se detectaron varios rostros',

    multipleFacesMessageText:
        'Solo una persona debe permanecer frente a la cámara durante la verificación.',

    clientHeaderText:
        'Error del dispositivo',

    clientMessageText:
        'No fue posible completar la verificación debido a un problema en el dispositivo.',

    serverHeaderText:
        'Error del servidor',

    serverMessageText:
        'No fue posible completar la verificación debido a un problema del servidor.',

    landscapeHeaderText:
        'Orientación no compatible',

    landscapeMessageText:
        'Gira tu dispositivo y colócalo en posición vertical.',

    portraitMessageText:
        'Mantén el dispositivo en posición vertical durante toda la verificación.',

    tryAgainText:
        'Intentar nuevamente'
};

export default es;
